/**
 * @fileoverview Core event constants.
 * Event naming convention: `embedded::{module}.{action}`
 */

/**
 * Event prefix for all embedded events.
 */
export const EVENT_PREFIX = "embedded::" as const;

/**
 * Iframe lifecycle events.
 */
export const IFRAME_EVENTS = {
  /** Initialize handshake - iframe signals it's ready to receive context */
  INIT: `${EVENT_PREFIX}iframe.ready`,
  /** App signals it's fully loaded and ready */
  READY: `${EVENT_PREFIX}ready`,
  /** App requests to be destroyed and navigate away */
  DESTROY: `${EVENT_PREFIX}destroy`,
} as const;

/**
 * Context events (Host → Iframe).
 */
export const CONTEXT_EVENTS = {
  /** Context data provision */
  PROVIDE: `${EVENT_PREFIX}context.provide`,
  /** Theme change notification */
  THEME_CHANGE: `${EVENT_PREFIX}theme.change`,
} as const;
